module.exports = __webpack_public_path__ + "img/landing02.47b35b32.jpg";